/* istanbul ignore file */

import { createContext, useContext } from 'react'
import { EppoClient } from '@eppo/js-client-sdk-common'
import { Store } from '@moonpig/web-core-types'

type DefaultSubjectAttributes = {
  storeId: Store['id']
  loggedIn: boolean
  userIsFromAd: boolean
  isBot: boolean
}

export type EppoExperimentOverrides = { [key: string]: string }

export const EppoContext = createContext<{
  client: EppoClient
  defaultSubjectAttributes: DefaultSubjectAttributes
  experimentOverrides: EppoExperimentOverrides
} | null>(null)

export const useEppoClient = () => useContext(EppoContext)?.client
export const useEppoDefaultSubjectAttributes = () =>
  useContext(EppoContext)?.defaultSubjectAttributes
export const useEppoExperimentOverrides = () =>
  useContext(EppoContext)?.experimentOverrides
